import React from 'react'
import { LaterceraWhite } from "copesa-logos"
import { Container, StLogo, StFooterContent } from "./style.css"
import Subscribe from '../../project/Subscribe'

const Footer = () => (
  <Container>
    <Subscribe />
    <StFooterContent>
      <a href="https://www.latercera.com/?utm_medium=especialeslt&utm_source=palestina&utm_content=footer&" className="slotLab" target="_blank" rel="noopener noreferrer">
        <StLogo>
          <LaterceraWhite />
        </StLogo>
      </a>
    </StFooterContent>
  </Container>
)

export default Footer